import { MenuOutlined } from "@ant-design/icons";
import { Avatar, Button, Dropdown, Flex, Select, Space } from "antd";
import { Link, useNavigate } from "react-router";
import DropdownIcon from "../../../assets/icons/DropdownIcon";
import IMAGES from "../../../assets/images";
import { ENV_CONFIG } from "../../../config/global.config";
import { LANGUAGES } from "../../../constants/global.constants";
import useAuth from "../../../hooks/useAuth";
import { cn } from "../../../utils/global.utils";
import { isActivePath } from "../../../utils/string.utils";
import useNavbar from "../_hooks/useNavbar";
import BdFlagIcon from "../_icons/BdFlagIcon";
import BdMiniFlagIcon from "../_icons/BdMiniFlagIcon";
import { menuItems } from "../constants";
import MobileDrawer from "./mobile-drawer";
import UserMenu from "./user-menu";

export default function Navbar() {
  const navigate = useNavigate();
  const { drawerVisible, showDrawer, closeDrawer } = useNavbar();
  const { isAuthenticated, employee } = useAuth();

  return (
    <nav className="bg-white shadow-[0px_4px_18px_0px_rgba(0,0,0,0.07)] sticky top-0 z-50">
      <div className="container">
        <Flex align="center" className="h-20">
          {/* Logo */}
          <Link className="cursor-pointer" to="/">
            <Flex align="center" gap={16}>
              <BdFlagIcon />
              <img
                src="/images/logo.svg"
                alt={ENV_CONFIG.APP_NAME}
                className="h-9 object-contain"
              />
            </Flex>
          </Link>

          {/* Right Side */}
          <div className="hidden xl:flex justify-end flex-1">
            <Flex align="center" className="space-x-6">
              {/* Desktop Menu */}
              <div className="hidden xl:flex items-center space-x-8 mr-6">
                {menuItems.map((item) => (
                  <Link
                    key={item.key}
                    to={`/${item.key}`}
                    className={cn(
                      "py-1 text-lg text-theme-neutral-800 hover:text-theme-primary transition-colors",
                      isActivePath(0, item.key) &&
                        "text-theme-primary border-b-2 border-theme-primary",
                    )}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>

              <Select
                prefix={<BdMiniFlagIcon className="mr-1.5" />}
                suffixIcon={<DropdownIcon />}
                className="language-select"
                size="small"
                placeholder="ভাষা"
                defaultValue={"bangla"}
                options={LANGUAGES}
              />

              {isAuthenticated ? (
                <Dropdown
                  trigger={["click"]}
                  overlay={<UserMenu />}
                  getPopupContainer={(trigger) => trigger.parentElement!}
                >
                  <Avatar
                    src={employee?.profilePhotoUrl || IMAGES.avatar}
                    size={48}
                    className="rounded-full cursor-pointer"
                  />
                </Dropdown>
              ) : (
                <Space size={16}>
                  <Button
                    variant="outlined"
                    type="primary"
                    size="large"
                    block
                    className="rounded-full btn-outline-primary pt-1 min-w-[90px]"
                    onClick={() => navigate(`/login`)}
                  >
                    লগইন
                  </Button>
                  <Button
                    type="primary"
                    size="large"
                    block
                    className="rounded-full pt-1 min-w-[120px]"
                    onClick={() => navigate(`/registration`)}
                  >
                    রেজিস্টার
                  </Button>
                </Space>
              )}
            </Flex>
          </div>

          {/* Mobile Menu Button */}
          <Flex justify="end" className="xl:hidden flex-1">
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={showDrawer}
              className="text-theme-gray-700"
            />
          </Flex>
        </Flex>
      </div>

      {/* Mobile Drawer */}
      <MobileDrawer drawerVisible={drawerVisible} closeDrawer={closeDrawer} />
    </nav>
  );
}
